var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"mb-4"},[_vm._v(" Please enter your bank details below ")]),_c('BankInfoForm',{attrs:{"update-info":_vm.showEditForm,"full-layout":"","onboarding":""},on:{"success":_vm.onSuccess,"cancel":function($event){return _vm.$emit('cancel')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }